import { ArrowsClockwise, CheckCircle, CloudSlash, WarningCircle } from '@phosphor-icons/react';
import { useSync } from '../sync/SyncContext';
import styles from './SyncIndicator.module.css';

const labels = {
  'saved-local': 'Salvo neste dispositivo',
  offline: 'Aguardando internet',
  syncing: 'Sincronizando',
  synced: 'Sincronizado',
  conflict: 'Conflito',
  error: 'Falha ao sincronizar'
} as const;

export function SyncIndicator({ compact }: { compact: boolean }) {
  const { status, pending, syncNow } = useSync();
  const Icon = status === 'synced' ? CheckCircle : status === 'offline' ? CloudSlash : status === 'conflict' || status === 'error' ? WarningCircle : ArrowsClockwise;
  return (
    <button type="button" className={`${styles.indicator} ${styles[status]}`} onClick={() => void syncNow()} title="Tentar sincronizar agora">
      <Icon size={18} className={status === 'syncing' ? styles.spin : undefined} weight="duotone" />
      {!compact && <span>{labels[status]}{pending > 0 ? ` · ${pending}` : ''}</span>}
      {compact && status !== 'synced' && <span className={styles.dot} aria-label={labels[status]} />}
    </button>
  );
}
